module.exports = __webpack_public_path__ + "static/media/level3.4007665a.jpg";